// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    $(document).ready(function() {

        // всплывашки с формами
        $('.fancy-form').fancybox({
            touch: false
        });

        // галерея выполненных работ
        $('.gratitude_block .block__content').photobox('a',{ time:0 });
        $('.view-frontpage .view-footer').photobox('a',{ time:0 });

        $('#slider .view-group').slick({
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 500,
            autoplayspeed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });

        $('.gratitude_block .field--name-field-gratitude-images').slick({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                { breakpoint: 992,
                    settings: { slidesToShow: 3 }
                },
                { breakpoint: 565,
                    settings: { slidesToShow: 2 }
                },
            ]
        });

        $('.sales_block .view-group').slick({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: true,
            responsive: [
                { breakpoint: 992,
                    settings: { slidesToShow: 2 }
                },
                { breakpoint: 565,
                    settings: { slidesToShow: 1 }
                },
            ]
        });

        $('.blog_block .view-group').slick({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                { breakpoint: 992,
                    settings: { slidesToShow: 2 }
                },
                { breakpoint: 565,
                    settings: { slidesToShow: 1 }
                },
            ]
        });

        // плавающая шапка
        $(window).scroll(function() {
            if ($(this).scrollTop() > 100){
                $('#navbar').addClass("glide");
            }
            else{
                $('#navbar').removeClass("glide");
            }
        });

        var currentYear = new Date().getFullYear();
        $(".copyright_box .field--name-body p.now_year").prepend(""+currentYear+" ");

        // получаем все кнопки навигации
        const tabsButtons = document.querySelectorAll('.nav-item');
        // Проходимся по всем кнопкам
        tabsButtons.forEach(btn => {
            // вешаем на каждую кнопку обработчик события клик
            btn.addEventListener('click', () => {
                // Получаем предыдущую активную кнопку
                const prevActiveItem = document.querySelector('.tab-pane.active');
                // Получаем предыдущую активную вкладку
                const prevActiveButton = document.querySelector('.nav-item.active');

                // Проверяем есть или нет предыдущая активная кнопка
                if (prevActiveButton) {
                    //Удаляем класс _active у предыдущей кнопки если она есть
                    prevActiveButton.classList.remove('active');
                }

                // Проверяем есть или нет предыдущая активная вкладка
                if (prevActiveItem) {
                    // Удаляем класс _active у предыдущей вкладки если она есть
                    prevActiveItem.classList.remove('active');
                }
                // получаем id новой активной вкладки, который мы перем из атрибута data-tab у кнопки
                const nextActiveItemId = `#${btn.getAttribute('data-tab')}`;
                // получаем новую активную вкладку по id
                const nextActiveItem = document.querySelector(nextActiveItemId);

                // добавляем класс _active кнопке на которую нажали
                btn.classList.add('active');
                // добавляем класс _active новой выбранной вкладке
                nextActiveItem.classList.add('active');
            });
        });

        // readmore service
        $('.services_block_front  .view-services').readmore({
            speed: 75,
            collapsedHeight: 960,
            moreLink: '<div class="rm_button"><a href="#" class="rm_button_more">Посмотреть все услуги</a></div>',
            lessLink: '',
        });

        $('.btn_close').click(function(){
            $('#nav_mobile').removeClass('show');
        });
        $('.fancy_bg_close').click(function(){
            $('#nav_mobile').removeClass('show');
        });

    });
})(jQuery);